import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import i18next from "i18next";
import RequestDialog from "./RequestDialog";
import ActionLink from "@mnjsplatform/components/lib/common/ActionLink";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";

class References extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            requestDialogVisible: false,
            showMessage: false,
            messageText: "",
            messageTitle: "",
            showReferences: false,
            isDataReady: false
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        this.setState({isDataReady: false});
        try {
            let key = {};
            await this.props.dispatch(this.props.EDocInfoOut_InfoPagePO.execute(key));
            if(!this.props.EDocInfoOut_InfoPagePO.isError) {
                const showReferences = this.props.EDocInfoOut_InfoPagePO.getField(0, 'IsEnableView2NDFL') === 1;
                if (showReferences) {
                    await this.props.dispatch(this.props.dataItem_List.execute(key));
                }
                this.setState({showReferences: showReferences, isDataReady: true});
            }
        } catch (e) {
            console.error(e);
        }
    }
    async refresh() {
        await this.props.dispatch(this.props.dataItem_List.execute());
    }
    createNewRequest = () => {
        this.setState({requestDialogVisible: true})
    }
    renderButtons = () => {
        return (<div className="modal-footer text-left mb-2">
            <button type="button" className="btn btn-regular -goahead ml1ex" data-dismiss="modal"
                    onClick={this.createNewRequest}>{i18next.t("New_Reference")}</button>
        </div>)
    }
    viewDocument = async (row) => {
        const token = await AuthProvider.getToken();
        const link = document.createElement("a");
        link.href = pathJoin(window.config.apiRoot, "References", "ViewDocument") + "?" + $.param({
            b_token: token,
            id: row.EDocInfoOutIntId
        });
        console.log(`url: ${link.href}`);
        link.click();
    }
    loadDocuments = async (row) => {
        const documentKey = this.props.dataItem_List.getRowKey(row);
        await this.props.dispatch(this.props.EDocInfoOut_GetForLoadListPO.execute(documentKey));
        console.log(`rowsCount: ${this.props.EDocInfoOut_GetForLoadListPO.rowsCount()}`);
        const delay = () => new Promise(resolve => setTimeout(resolve, 1000));

        if(!this.props.EDocInfoOut_GetForLoadListPO.isError && this.props.EDocInfoOut_GetForLoadListPO.rowsCount() > 0){
            const token = await AuthProvider.getToken();
            for(const rowFile of this.props.EDocInfoOut_GetForLoadListPO.rawData.DataTable){
                const fileKey = this.props.EDocInfoOut_GetForLoadListPO.getRowKey(rowFile);
                const key = Object.assign({}, {b_token: token}, fileKey);
                const link = document.createElement("a");
                link.href = pathJoin(window.config.apiRoot, "References", "LoadDocument") + "?" + $.param(key);
                console.log(`url: ${link.href}`);
                link.click();
                await delay();
            }
        }
    }
    renderCellEx = (cellParams) => {
        if (cellParams.fieldInfo.Name === 'DocViewText') {
            if (cellParams.row['DocViewEnable'] === 1) {
                return (
                    <div style={{cursor: "pointer"}}>
                        <ActionLink onSelect={async () => {
                            await this.viewDocument(cellParams.row);
                        }}>
                            {cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex)}
                        </ActionLink>
                    </div>
                )
            }
        } else if (cellParams.fieldInfo.Name === 'DocLoadText') {
            if (cellParams.row['DocLoadEnable'] === 1) {
                return (
                    <div style={{cursor: "pointer"}}>
                        <ActionLink onSelect={async () => {
                            await this.loadDocuments(cellParams.row);
                        }}>
                            {cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex)}
                        </ActionLink>
                    </div>
                )
            }
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }
    render() {
        if (!this.state.isDataReady)
            return null;
//        const pageLines = (this.props.EDocInfoOut_InfoPagePO.getField(0, 'TextView') || '').split('\n') || [];

        return (
            <React.Fragment>
                <MessageBox visible={this.state.showMessage}
                            title={this.state.messageTitle}
                            messageText={this.state.messageText}
                            onClose={this.onMessageClose}/>
                <PlaceholderWrapper placeholderId="10"
                                    title={<><i className='fa fa-chain-broken'/> {i18next.t("References_3")}</>}
                                    showSplitterLine={false} canCollapse={false}>
{/*
                    {pageLines && pageLines.length > 0 &&
                        <PlaceholderWrapper placeholderId="20" showSplitterLine={false} canCollapse={false}
                        staticTitle={i18next.t("Справки")}>
                            {
                                pageLines.map((row, index) => <>{row}<br/></>)
                            }
                        </PlaceholderWrapper>
                    }
*/}
                    {this.state.showReferences &&
                        <React.Fragment>
                            {this.renderButtons()}
                            <GridView dataItem={this.props.dataItem_List} renderCellEx={this.renderCellEx}/>
                            {this.state.requestDialogVisible &&
                                <RequestDialog onClose={
                                    async () => {
                                        this.setState({requestDialogVisible: false});
                                        await this.refresh();
                                    }
                                }></RequestDialog>
                            }
                        </React.Fragment>
                    }
                </PlaceholderWrapper>
            </React.Fragment>
        )
    }
}

References.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_List: PropTypes.object,
    dataItem_ViewInfo: PropTypes.object,
    dataItem_CreateInfo: PropTypes.object,
    dataItem_SelectYear: PropTypes.object,
    EDocInfoOut_InfoPagePO: PropTypes.object,
    EDocInfoOut_GetForLoadListPO: PropTypes.object,
    EDocInfoOut_GetForLoadFilePO: PropTypes.object
}

References.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_List: state.referencesState.EDocInfoOut_List2NDFL_PO,
        dataItem_ViewInfo: state.referencesState.EDocInfoOut_GetForViewPO,
        EDocInfoOut_InfoPagePO: state.referencesState.EDocInfoOut_InfoPagePO,
        EDocInfoOut_GetForLoadListPO: state.referencesState.EDocInfoOut_GetForLoadListPO,
        EDocInfoOut_GetForLoadFilePO: state.referencesState.EDocInfoOut_GetForLoadFilePO
    }
}

export default connect(mapStateToProps)(References)